import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Home, FileText, Sparkles, MessageSquare, Settings } from 'lucide-react';
import { useFeatureFlagEnabled } from 'posthog-js/react';
import { useAssistantV2Enabled } from '../../modules/assistant/flag';
import '../ReportsNative/ReportsNative.css';

/**
 * Mobile-browser bottom tab bar — the web twin of the native app's tabs
 * (Dashboard · Reports · AI · Chat · Settings), same routes as desktop.
 * Lodge Orange active state, safe-area aware, hidden in print.
 */
const TABS = [
  { key: 'dashboard', label: 'Dashboard', icon: Home, to: '/dashboard/revenue', match: ['/dashboard'] },
  { key: 'reports', label: 'Reports', icon: FileText, to: '/reports', match: ['/reports', '/report/'] },
  // /ai-assistant opens v2 where it has taken Lodgeic AI's place.
  { key: 'ai', label: 'AI', icon: Sparkles, to: '/ai-assistant', match: ['/ai-assistant', '/assistant'], flag: 'ai-assistant' },
  { key: 'chat', label: 'Chat', icon: MessageSquare, to: '/chat', match: ['/chat'] },
  { key: 'settings', label: 'Settings', icon: Settings, to: '/settings', match: ['/settings'] },
];

export default function MobileTabBar() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const aiEnabled = useFeatureFlagEnabled('ai-assistant');
  const assistantV2 = useAssistantV2Enabled();
  const tabs = TABS.filter((t) => !t.flag || (t.flag === 'ai-assistant' && (aiEnabled !== false || assistantV2)));

  return (
    <nav className="rn-tabbar" aria-label="Primary">
      {tabs.map((t) => {
        const active = t.match.some((m) => pathname === m || pathname.startsWith(`${m}/`) || pathname.startsWith(m));
        const Icon = t.icon;
        return (
          <button
            key={t.key}
            type="button"
            className={`rn-tab${active ? ' rn-tab-active' : ''}`}
            onClick={() => navigate(t.to)}
            aria-current={active ? 'page' : undefined}
          >
            <Icon size={20} strokeWidth={active ? 2.4 : 1.9} />
            <span>{t.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
